// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-field-body {
   border-style: none;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: -5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

.validate-error {
   border-color: red;
}

.holder, input {
   margin: 4px 10px 10px 12px !important;
   height: 200px;
   border: 1px #ccc dashed;
   background-color: #F6F7F8;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.fa-upload {
   margin-right: 10px;
}

img {
   width: auto !important;
}

.signature {
   background-color: #fff;
   border: 2px dashed #cccccc;
   border-radius: 10px;
   cursor: pointer;
   height: 70px;
   margin: 4px 12px 10px 12px;
}

.signature img {
   max-height: 50px;
   max-width: 220px;
}

.default-cursor {
   cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/signature/signature.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;AACrB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,gBAAgB;GAChB,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,qCAAqC;GACrC,aAAa;GACb,uBAAuB;GACvB,yBAAyB;AAC5B;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,sBAAsB;AACzB;;AAEA;GACG,sBAAsB;GACtB,0BAA0B;GAC1B,mBAAmB;GACnB,eAAe;GACf,YAAY;GACZ,0BAA0B;AAC7B;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,eAAe;AAClB","sourcesContent":[".txt-field-body {\n   border-style: none;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: -5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\n.validate-error {\n   border-color: red;\n}\n\n.holder, input {\n   margin: 4px 10px 10px 12px !important;\n   height: 200px;\n   border: 1px #ccc dashed;\n   background-color: #F6F7F8;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.fa-upload {\n   margin-right: 10px;\n}\n\nimg {\n   width: auto !important;\n}\n\n.signature {\n   background-color: #fff;\n   border: 2px dashed #cccccc;\n   border-radius: 10px;\n   cursor: pointer;\n   height: 70px;\n   margin: 4px 12px 10px 12px;\n}\n\n.signature img {\n   max-height: 50px;\n   max-width: 220px;\n}\n\n.default-cursor {\n   cursor: default;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
